<template>
  <a :target="target" v-if="external" :class="{ removeDecorations }" :href="location">
    <slot>
      {{ name }}
    </slot>
  </a>

  <router-link v-else :to="linkTo" :class="{ removeDecorations }">
    <slot>
      {{ name }}
    </slot>
  </router-link>
</template>

<script>
export default {
  props: {
    target: {
      type: String,
    },
    external: {
      type: Boolean,
      default: false,
    },
    location: {
      type: String,
      required: true,
      default: "/",
    },
    name: {
      type: String,
    },
    removeDecorations: {
      type: Boolean,
      default: false,
    },
    // 新增查询参数
    query: {
      type: Object,
      default: () => ({})
    },
    // 新增路径参数
    params: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    linkTo() {
      return {
        path: this.location,
        query: this.query,
        params: this.params
      };
    }
  }
};
</script>

<style>
.removeDecorations {
  color: #484848;
  text-decoration: none;
}
</style>
